import React from 'react';

const OutlinedIcon = ({ stroke, ...props }: { stroke?: string }) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.5"
      y="0.5"
      width="63"
      height="63"
      rx="7.5"
      fill="white"
      stroke={stroke !== '#6930CA' ? '#A6A7B0' : stroke}
    />
    <rect
      x="26.2441"
      y="11.6409"
      width="31"
      height="31"
      rx="3.5"
      transform="rotate(20 26.2441 11.6409)"
      fill="#F4F6F9"
      stroke="#E6E9EE"
    />
    <rect
      x="29.7871"
      y="20.9116"
      width="15"
      height="13"
      rx="1"
      transform="rotate(20 29.7871 20.9116)"
      fill="#F4F6F9"
      stroke={stroke}
      strokeWidth="2"
    />
    <rect
      x="32.5195"
      y="25.0991"
      width="15"
      height="13"
      rx="1"
      transform="rotate(20 32.5195 25.0991)"
      fill="#F4F6F9"
      stroke={stroke}
      strokeWidth="2"
    />
    <circle
      cx="41.1074"
      cy="34.3435"
      r="1.5"
      transform="rotate(20 41.1074 34.3435)"
      fill={stroke}
    />
    <path
      d="M30.7277 21.254C29.3254 21.9658 28.6283 24.0518 34.416 25.7393"
      stroke={stroke}
      strokeWidth="2"
    />
    <path
      d="M25.7403 32.2081C25.2272 33.6177 23.3466 36.0193 28.7457 37.5587"
      stroke={stroke}
      strokeWidth="2"
    />
    <rect
      x="27.3105"
      y="29.8545"
      width="2"
      height="3"
      transform="rotate(20 27.3105 29.8545)"
      fill="#F4F6F9"
    />
    <path
      d="M25.2404 33.4056L28.0779 25.6096C28.2668 25.0906 28.8406 24.823 29.3596 25.0119L30.2993 25.354C30.8183 25.5429 31.0859 26.1167 30.897 26.6357L27.8188 35.0929C27.6299 35.6119 27.0558 35.8639 26.6197 35.525C26.1633 35.1701 25.7238 34.7162 25.3987 34.3408C25.176 34.0836 25.124 33.7253 25.2404 33.4056Z"
      fill={stroke}
      stroke={stroke}
      strokeWidth="2"
    />
    <rect
      x="17.4271"
      y="15.0441"
      width="31"
      height="31"
      rx="3.5"
      transform="rotate(10 17.4271 15.0441)"
      fill="#F4F6F9"
      stroke="#E6E9EE"
    />
    <rect
      x="22.526"
      y="23.5588"
      width="15"
      height="13"
      rx="1"
      transform="rotate(10 22.526 23.5588)"
      fill="#F4F6F9"
      stroke={stroke}
      strokeWidth="2"
    />
    <rect
      x="25.944"
      y="27.2083"
      width="15"
      height="13"
      rx="1"
      transform="rotate(10 25.944 27.2083)"
      fill="#F4F6F9"
      stroke={stroke}
      strokeWidth="2"
    />
    <circle
      cx="36.0078"
      cy="34.8207"
      r="1.5"
      transform="rotate(10 36.0078 34.8207)"
      fill={stroke}
    />
    <path
      d="M23.5114 23.7329C22.254 24.6774 21.9297 26.8528 27.9226 27.5096"
      stroke={stroke}
      strokeWidth="2"
    />
    <path
      d="M20.5008 35.3874C20.2403 36.8646 18.8053 39.5563 24.3897 40.1349"
      stroke={stroke}
      strokeWidth="2"
    />
    <rect
      x="21.6406"
      y="32.7959"
      width="2"
      height="3"
      transform="rotate(10 21.6406 32.7959)"
      fill="#F4F6F9"
    />
    <path
      d="M20.2177 36.6532L21.6584 28.4829C21.7543 27.939 22.2729 27.5758 22.8168 27.6717L23.8016 27.8453C24.3455 27.9412 24.7087 28.4599 24.6128 29.0038L23.05 37.8671C22.9541 38.411 22.4324 38.7589 21.9442 38.5008C21.433 38.2306 20.9213 37.8599 20.536 37.5466C20.272 37.3321 20.1587 36.9882 20.2177 36.6532Z"
      fill={stroke}
      stroke={stroke}
      strokeWidth="2"
    />
    <rect
      x="9.5"
      y="19.5"
      width="31"
      height="31"
      rx="3.5"
      fill="#F4F6F9"
      stroke="#E6E9EE"
    />
    <path
      d="M26.376 22.4489C25.9765 22.1572 25.4947 22 25 22C24.5053 22 24.0235 22.1572 23.624 22.4489L13.7293 29.6689C12.4253 30.6196 13.0987 32.6822 14.7107 32.6822H15V40.4156C14.3979 40.7228 13.8925 41.1905 13.5395 41.767C13.1866 42.3435 12.9999 43.0063 13 43.6822V45.6822C13 46.2329 13.448 46.6822 14 46.6822H36C36.2652 46.6822 36.5196 46.5769 36.7071 46.3893C36.8946 46.2018 37 45.9475 37 45.6822V43.6822C37.0001 43.0063 36.8134 42.3435 36.4605 41.767C36.1075 41.1905 35.6021 40.7228 35 40.4156V32.6822H35.2893C36.9027 32.6822 37.5733 30.6196 36.2707 29.6689L26.376 22.4489ZM24.8027 24.0636C24.8598 24.0219 24.9286 23.9994 24.9993 23.9994C25.07 23.9994 25.1389 24.0219 25.196 24.0636L34.2667 30.6822H15.7333L24.8027 24.0636ZM33 32.6822V40.0156H30.3333V32.6822H33ZM28.3333 32.6822V40.0156H26V32.6822H28.3333ZM24 32.6822V36.3489V40.0156H21.6667V32.6822H24ZM16.6667 42.0156H33.3333C34.2533 42.0156 35 42.7622 35 43.6822V44.6822H15V43.6822C15 42.7622 15.7467 42.0156 16.6667 42.0156ZM17 40.0156V32.6822H19.6667V40.0156H17Z"
      fill={stroke}
    />
  </svg>
);

export default OutlinedIcon;
